import comp from "./AddToLibraryModal";
export default comp;
